// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/2189d0bd/" + chunkId + "." + __webpack_require__.h() + ".v2189d0bd.js";
};